import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {ModalController, Platform} from '@ionic/angular';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { environment } from '../environments/environment';
import { AnalyticsService } from '../smoothr-web-app-core/services/analytics/analytics.service';
import { Api } from '../smoothr-web-app-core/api/api';
import { NAVIGATIONURLS, NavigationService } from './services/navigation.service';
import { register } from 'swiper/element/bundle';
import { BrazeService } from './services/braze.service';
import { RepositoryService } from 'src/smoothr-web-app-core/services/repository/repository.service';
import { CookieConsentService } from './services/cookie.service';
import { BehaviorSubject, Observable, catchError, filter, of, switchMap } from 'rxjs';
import Order from 'src/smoothr-web-app-core/models/Order';
import { DeviceDetectorService } from './services/device-detector.service';
import {PaymentStatus} from "../smoothr-web-app-core/models/PaymentStatus";
import Payment from "../smoothr-web-app-core/models/Payment";
import {PaymentCancelledModalComponent} from "./components/payment-cancelled-modal/payment-cancelled-modal.component";
import {InfoModalComponent} from "./components/info-modal/info-modal.component";
import {PaymentModalResult} from "../smoothr-web-app-core/components/payment-modal/payment-modal.component";

register();

@Component({
	selector: 'app-root',
	templateUrl: 'app.component.html',
	styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
	static largeScreen = false;
	static analyticsEnabled = false;
	isCookieAccepted = false;
	static isWebApp = true;
	static isNativeApp = false;
	public trackAuthUrl$: Observable<{
		order: boolean;
		auth: boolean;
		home: boolean;
		promo: boolean;
	}>;
	public order$ = new BehaviorSubject<Order | null>(null);

	public isDesktop$!: Observable<boolean>;

	constructor(
		private router: Router,
		// private route: ActivatedRoute,
		private analytics: AnalyticsService,
		platform: Platform,

		private navigationService: NavigationService,
		private brazeService: BrazeService,
		private cookieService: CookieConsentService,
		public translate: TranslateService,
		private repository: RepositoryService,
		private deviceDetector: DeviceDetectorService,
		private modalCtrl: ModalController
	) {
		// this.route.queryParams.subscribe(params => {
		// 	console.log('Params = ' + JSON.stringify(params));
		// 	if(params.id && params.auth) {
		// 		try {
		// 			Api.oneTimeLogin(params.id, params.auth).then((res) => {
		// 				console.log("User data:" + res.data);
		// 				this.repository.customerAuth.emit(res.data);
		// 				this.router.navigate(['/order']);
		// 			})
		// 		} catch (error) {
		// 			console.log(error);
		// 		}
		// 	}
		// });
		console.log(environment.customerGroup + ' ' + environment.version);
		const favIcon: any = document.querySelector("link[rel*='icon']") || document.createElement('link');
		favIcon.type = 'image/x-icon';
		favIcon.rel = 'shortcut icon';
		favIcon.href = '/assets/eintracht/logo.svg';
		document.getElementsByTagName('head')[0].appendChild(favIcon);
		document.title = translate.instant('index.title.' + environment.customerGroup);

		this.handleCookieConsent();
		const languageValue = localStorage.getItem('langOfApp');
		console.log(languageValue);
		if (languageValue) {
			translate.setDefaultLang(languageValue);
			translate.use(languageValue);
		} else {
			translate.setDefaultLang('de');
			translate.use('de');
		}

		translate.onLangChange.subscribe(languageChanged => {
			if (languageChanged) localStorage.setItem('langOfApp', languageChanged.lang);
		});
		this.repository.obserableOrder.subscribe(order => {
			this.order$.next(order);
		});
		this.trackAuthUrl$ = this.router.events.pipe(
			filter(event => event instanceof NavigationStart),
			switchMap((eventData: NavigationStart) =>
				of({
					auth: eventData?.url?.includes(NAVIGATIONURLS.allInfo()),
					order: eventData?.url?.includes('/' + NAVIGATIONURLS.order()),
					home: eventData?.url?.includes(NAVIGATIONURLS.home()),
					promo: eventData?.url?.includes(NAVIGATIONURLS.promo()),
				})
			),
			catchError(e => {
				return of({
					order: false,
					auth: false,
					home: false,
					promo: false,
				});
			})
		);

		platform.ready().then(() => {
			AppComponent.largeScreen = platform.width() >= 992;
			platform.resize.subscribe(() => {
				AppComponent.largeScreen = platform.width() >= 992;
			});
			console.log(new Date());
			try {
				setTimeout(() => {
					console.log('START', document.getElementById('app-root'));
					document.getElementById('app-root').style.opacity = '1';
					document.getElementById('splash-screen')?.remove();
					console.log(new Date());
				}, 4000);
			} catch (e) {}
		});
		Api.isMaintenanceActive()
			.then(result => {
				if (result) {
					this.navigationService.maintenance();
				}
			})
			.catch(error => {
				console.log(error);
			});


		this.checkPayments()
	}
	private disableSdkBraze() {
		this.brazeService.disableSdk();
	}

	ngOnInit() {
		this.isDesktop$ = this.deviceDetector.isDesktop$;
	}

	ngDoCheck() {}

	private handleCookieConsent() {
		try {
			this.cookieService.initializeCookieConsent();
		} catch (e) {}
	}

	async setAnalyticsEnabled(enabled: boolean) {
		await this.analytics.setAnalyticsCollectionEnabled(enabled);
	}

	checkPayments() {
		if (this.router.url.includes(''))
		this.repository.checkOpenPayment().then(async result => {
			if (!result) {
				this.repository.payment.emit(null);
				console.log('No Payment open.', result);
				return;
			}
			console.log(result);
			console.log({
				paymentDone: result.payment?.status === PaymentStatus.done,
				orderIsPaid: result.order?.isPayed,
			});
			const definitelyFailed = result.payment?.status === PaymentStatus.failed || result.payment?.status === PaymentStatus.cancelled;
			if (definitelyFailed) {
				this.showErrorPayment(result.payment, result.order);
				return;
			}
			// Not a confirmed failure (done, still pending, or indeterminate after the short
			// check above) - hand off to the payment/success page, which keeps reconciling
			// with the backend for several minutes instead of giving up here on the spot.
			console.log('Navigate to payment success.');
			const name = this.router.parseUrl(this.router.url).queryParams['name'];
			const params = { order: result.payment?.orders[0] ?? result.order?._id}
			if (name) params['name'] = name;
			await this.router.navigate(['/payment/success/', result.payment?._id ?? result.order?.paymentId], {
				queryParams: params,
			});
		});
	}

	async showErrorPayment(payment: Payment, order: Order) {
		const retryResponse = await PaymentCancelledModalComponent.show(this.modalCtrl);
		if (!retryResponse) {
			await InfoModalComponent.show(this.modalCtrl, {
				title: this.translate.instant('error_dialog.title'),
				info: this.translate.instant('error_dialog.info'),
				closeButton: this.translate.instant('error_dialog.closeButton'),
			});
			this.repository.payment.next(null);
			return;
		}
		const venue = JSON.parse(localStorage.getItem('venue'));
		const result = await this.repository.showPaymentModal(
			this.modalCtrl,
			venue,
			order,
			this.repository._customerAuth.customer,
			payment.tip,
			false
		);
		if (result?.result === PaymentModalResult.SUCCESS) {
			this.repository.verifiedOrder.emit(order);
			this.repository.payment.emit(result.payment);
			await this.navigationService.paymentSuccess(order._id, result.payment._id);
			return;
		}
	}

	openPage(value: string) {
		if (!value) {
			return;
		}
		this.router.navigate([value]);
	}
	orderClick() {}
	later() {}
}
